export default "__VITE_ASSET__BDWOkZxC__"